<template>
	<div class="single-mapping-editor pt-2">
		<div>
			<div class="font-size-sm mb-1">Name in your {{ serviceName }} account</div>
			<BasicTextField disabled :value="valueOfMapping" />
			<div class="flex-start--center generic-name">
				<SubFolderSvg class="sub-folder-svg" />
				<div class="sub-item pl-4 flex-1">
					<div class="font-size-sm mt-3 mb-1">Generic name anyone can understand</div>
					<BasicTextField v-model="localDisplayName" />
				</div>
			</div>
		</div>

		<RemoveIcon class="hover-btn-effect mt-1" @click="$emit('remove-option', mapping)" />
	</div>
</template>

<script>
import debounce from 'lodash/debounce';
import SubFolderSvg from './assets/SubFolderSvg';
import RemoveIcon from '@/components/BlockEditorWidget/assets/icon-remove-option.svg';

export default {
	name: 'SingleMappingEditor',
	props: {
		mapping: { type: Object },
		serviceName: { type: String },
		mappingOutputLabel: { type: String },
	},
	components: {
		RemoveIcon,
		SubFolderSvg,
	},
	computed: {
		valueOfMapping() {
			return this.mappingOutputLabel || this.mapping.originalKey;
		},
	},
	mounted() {
		this.localDisplayName = this.mapping.displayName;
	},
	watch: {
		localDisplayName: {
			handler: debounce(function (value) {
				if (value !== this.mapping.displayName) {
					const mapping = { ...this.mapping, displayName: value };
					this.$emit('save-mapping', mapping);
				}
			}, 300),
		},
	},
	data() {
		return {
			localDisplayName: '',
		};
	},
};
</script>

<style scoped lang="scss">
.single-mapping-editor {
	.generic-name {
		position: relative;
		.sub-folder-svg {
			position: absolute;
			transform: rotate(90deg) translate(-5px, 15px);
		}
		.sub-item {
			margin-left: 2px;
		}
	}
}
</style>
